import React from 'react';
import { RoomDetailStyled } from './room-detail.styled';
import Button from '../../../base/button/button';
import { ButtonVariant } from '../../../base/button/constants';
import Carousel from 'react-material-ui-carousel';
import {
  RoomDetailContainerCarousel,
  RoomDetailContainerDescription,
  RoomDetailMarginCarouselLeft, RoomDetailMarginCarouselRight,
  RoomDetailVariant
} from './constants';

export interface RoomDetailProps {
  buttonTitle: string;
  onPressButton?: () => void;
  room: any;
  imagePosition?: 'left' | 'right';
  variant?: RoomDetailVariant
}
const RoomDetail = (props: RoomDetailProps) => {
  const { imagePosition = 'right', variant = RoomDetailVariant.RoomPage } = props;
  console.log(props.room.images)

  return (
    <RoomDetailStyled.Container container>
      <RoomDetailStyled.ContainerRoom container variant={variant}>
        {imagePosition === 'left' && props.room.images && (
          <RoomDetailStyled.ContainerCarousel item xs={12} md={RoomDetailContainerCarousel[variant]} margindesktop={RoomDetailMarginCarouselLeft[variant]} marginmobile={"0px 0px 10px 0px"}>
            <Carousel
              indicatorContainerProps={{
                style: {
                  zIndex: 1,
                  position: "absolute",
                  bottom: 0,
                  left: "50%",
                  transform: "translate(-50%, -50%)"

                }
              }}
              sx={{ width: '100%' }}
              indicators={true}
              navButtonsAlwaysInvisible={true}
              stopAutoPlayOnHover={false}
              interval={4000}
            >
              {props.room.images.map((item: any, index: number) => (
                <RoomDetailStyled.ContainerImages key={index}>
                  <RoomDetailStyled.Image
                    object-fit={'contain'}
                    src={item.image}
                  />
                </RoomDetailStyled.ContainerImages>
              ))}
            </Carousel>
          </RoomDetailStyled.ContainerCarousel>
        )}
        <RoomDetailStyled.ContainerDetails item xs={12} md={RoomDetailContainerDescription[variant]}>
          <RoomDetailStyled.RoomName>
            {props.room.name}
          </RoomDetailStyled.RoomName>
          <RoomDetailStyled.RoomDescription>
            {props.room.description}
          </RoomDetailStyled.RoomDescription>
          {/*<RoomDetailStyled.ContainerButton>*/}
          {/*  <Button*/}
          {/*    variant={ButtonVariant.Dark}*/}
          {/*    onClick={props.onPressButton}*/}
          {/*    label={props.buttonTitle}*/}
          {/*  />*/}
          {/*</RoomDetailStyled.ContainerButton>*/}
        </RoomDetailStyled.ContainerDetails>
        {imagePosition === 'right' && props.room.images && (
          <RoomDetailStyled.ContainerCarousel item xs={12} md={RoomDetailContainerCarousel[variant]}  margindesktop={RoomDetailMarginCarouselRight[variant]} marginmobile={"10px 0px 0px 0px"}>
            <Carousel
              indicatorContainerProps={{
                style: {
                  zIndex: 1,
                  position: "absolute",
                  bottom: 0,
                  left: "50%",
                  transform: "translate(-50%, -50%)"

                }
              }}
              sx={{ width: '100%' }}
              indicators={true}
              navButtonsAlwaysInvisible={true}
              stopAutoPlayOnHover={false}
              interval={4000}
            >
              {props.room.images.map((item: any, index: number) => {
                return <RoomDetailStyled.ContainerImages key={index}>
                  <RoomDetailStyled.Image
                    src={item.image}
                  />
                </RoomDetailStyled.ContainerImages>
              })}
            </Carousel>
          </RoomDetailStyled.ContainerCarousel>
        )}
      </RoomDetailStyled.ContainerRoom>
    </RoomDetailStyled.Container>
  );
};

export default RoomDetail;
